import React from "react";
import { useTranslation } from "react-i18next";
import cn from "clsx";
import { determineIsSizeChart } from "@/util/add-to-cart";
import "./style.scss";

const ProductErrorInfo = ({
  product,
  selectedSizeFullData,
  productSizeChart,
  showProductSizeChart,
  showShippingOptionsModal
}) => {
  const { t } = useTranslation("productDetails");
  const isSizeChart = determineIsSizeChart(productSizeChart ?? []);
  const sizeStock = selectedSizeFullData.size?.sizeStock;
  const isLowStock = sizeStock && sizeStock <= 5 && !product.isSizeSelectable;
  const isAnyErrorInfo = isLowStock || !product.pstock;

  return (
    <div
      className={cn("item_product_error_info", {
        "p-0": !isAnyErrorInfo,
        "w-100": isAnyErrorInfo
      })}
    >
      {isLowStock && (
        <span className="stock_limit">
          {t("itemsInStockAvailable", {
            count: sizeStock
          })}
        </span>
      )}
      {!product.pstock && (
        <span className="stock_limit">{t("outOfStock")}</span>
      )}
      <span className="return_info" onClick={showShippingOptionsModal}>
        {t("deliveryInfo")}
      </span>
      {!!isSizeChart && (
        <span className="sizing_help" onClick={showProductSizeChart}>
          {t("needSizing")}
        </span>
      )}
    </div>
  );
};

export default ProductErrorInfo;
